import React, { FC, memo } from 'react';

import Social from '../../../components/social';
import ResultSuccessImg from './result-success.svg';

interface ResultSuccessProps {}

const ResultSuccess: FC<ResultSuccessProps> = memo(() => {
  return (
    <>
      <img src={ResultSuccessImg} alt="" className="result__img" />
      <p className="result__text">
        Ваша интернет-броня непробиваема: вы&nbsp;знаете, как обойти киберловушки и&nbsp;когда отложить гаджет в&nbsp;сторону. Дети и&nbsp;все близкие&nbsp;&mdash; под надёжной защитой ваших знаний.
      </p>
      <p className="result__comment">
        Оградить ребёнка от угроз в интернете поможет Детская почта — с суперзащитой от мошенников и спама.
      </p>
      <a href="https://trk.mail.ru/c/ieedu7?mt_adset=safemail_test&mt_network=landing&mt_campaign=safemail_kids&mt_creative=1june" target="_blank" rel="noreferrer" className="button -blue">
        Узнать больше
      </a>
      <div className="result__share">
        Поделитесь тестом с друзьями и предложите им проверить себя:
        <Social className="-big" type="result" />
      </div>
    </>
  );
});

export default ResultSuccess;
